import { createRequestFilters, ListProviderTransactionsRequest, Transaction } from '@enter/core';
import { action, observable, runInAction } from 'mobx';
import { IFeatures, IItemDetail, IItemListing, IItemListingRequest } from './root.store';
import { TransactionGenerator } from './transaction.generator';
import { TransactionService } from './transaction.service';
import { appendTo, parseItemListingRequest } from './util';

export class TransactionStore {
    @observable public transactions: Transaction[] = [];

    private features: IFeatures;
    private transactionGenerator: TransactionGenerator;
    private transactionService: TransactionService = new TransactionService();

    constructor(features: IFeatures, transactionGenerator: TransactionGenerator) {
        this.features = features;
        this.transactionGenerator = transactionGenerator;
    }

    @action
    public async loadTransactionListing(ilr: IItemListingRequest): Promise<IItemListing<Transaction>> {
        const lpgr = ilr2lptr(ilr);
        const listing = await (this.features.isDemo
            ? this.transactionGenerator.loadTransactionListing(lpgr)
            : this.transactionService.fetchTransactionListing(lpgr));
        if (!listing) {
            throw new Error(`No transactions available`);
        }
        const { items } = listing;
        runInAction(() => {
            this.transactions = appendTo<Transaction>(this.transactions, items);
        });
        return listing;
    }

    @action
    public async loadTransactionDetail(id: string): Promise<IItemDetail<Transaction>> {
        const detail = await (this.features.isDemo
            ? this.transactionGenerator.loadTransactionDetail(id)
            : this.transactionService.fetchTransactionDetail(id));
        if (!detail) {
            throw new Error(`No transaction items available`);
        }
        return detail;
    }
}

// Convert from IItemListingRequest to ListProviderTransactionItemsRequest
export const ilr2lptr = (ilr: IItemListingRequest): ListProviderTransactionsRequest => {
    const base = parseItemListingRequest(ilr) as ListProviderTransactionsRequest;
    const filters = createRequestFilters(ilr.filters, true);
    return {
        ...base,
        ...filters,
    };
};
